import React, {Component} from "react";
import ReactQuill from 'react-quill';

class TextEditor extends Component {
	render() {
		let modules = {
			toolbar: [
				[{ 'header': [1, 2, false] }],
				['bold', 'italic', 'underline','strike', 'blockquote'],
				[{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
				['link'],
				['clean']
			],
		}

		let formats = [
			'header',
			'bold', 'italic', 'underline', 'strike', 'blockquote',
			'list', 'bullet', 'indent',
			'link'
		]
		return <ReactQuill {...this.props} theme="snow" modules={modules} formats={formats} />
	}
}

export default TextEditor;


// WEBPACK FOOTER //
// ./src/elements/forms/wysiwyg_field.js